import React from 'react';
import {reduxForm} from 'redux-form';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {navigationStates} from '../../../../enums/navigationStates';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import {gridsNames} from '../../../../enums/gridsNames';
import {FetchEntitiesFilters} from '../../../../enums/fetchEntitiesFilters';
import {EntityPropertyTypes} from '../../../../enums/entityPropertyTypes';
import LastOperationCell from '../../../Common/CustomGridCells/LastOperationCell/lastOperationCell';
import LabelWithTooltipCell from '../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell';
import EntityIdCell from '../../../Common/CustomGridCells/EntityIdCell/entityIdCell'
import {alertStatus, getAlertColumnFilterSections} from '../../../../utils/alertFilterSectionHelper';
import AssetAlertPopoverCell from '../../../Common/CustomGridCells/AssetAlertPopoverCell/assetAlertPopoverCell';
import ToolUsageProgressCell from '../../../Common/CustomGridCells/ToolUsageProgressCell/toolUsageProgressCell';
import ToolTypeHelper from '../../../../utils/toolTypeHelper';
import {filterAlignmentTypes} from 'infrastructure/js/enums/filterAlignmentTypes';
import {enumTypes, getEnumLabel} from '../../../../utils/enumHelper';

require('./activeToolsGrid.scss');

class ActiveToolsGrid extends React.PureComponent {

  filterConfig = [
    {fieldName: 'assetAlert', filterName: 'assetAlert'},
    {fieldName: 'maxNumOfCycles', filterName: ''},
    {fieldName: 'currentCyclesNumber', filterName: 'currentCycleNumber'},
    {fieldName: 'toolType.businessId', filterName: 'toolType', getOptions: true},
    {fieldName: 'businessId', filterName: 'businessId', getOptions: false},
    { fieldName: 'toolType.toolCategory.businessId', filterName: 'toolCategoryBusinessId', getOptions: true },
    {fieldName: 'toolType.kitTypesWithCapacity', filterName: 'toolKitType', getOptions: true },
    {fieldName: 'location', filterName: 'assetLocationName', getOptions: true},
    {fieldName: 'toolStatus', filterName: 'toolStatus', getOptions: true},
    {fieldName: 'lastOperation', filterName: 'assetLastOperationDate', getOptions: true},
    {fieldName: 'toolType.configurationType', filterName: 'configurationType', getOptions: true },
  ]

  constructor(props) {
    super(props);
    this.labels = createLabelHelper('mat.grid.');
    this.toolStatusLabels = createLabelHelper('enum.tool.status.');

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'assetAlert',
        title: this.labels.get('columns.alert.title'),
        filterType: filterTypes.MULTI_SECTIONS,
        filterName: 'assetAlert',
        filterSections: getAlertColumnFilterSections([alertStatus.NO_ALERT,alertStatus.WARNING,alertStatus.ERROR]),
        width: 120,
        columnOptions: {
          cellComponent: AssetAlertPopoverCell,
          valueGetter: (params) => {
            return {
              description: '',
              alerts: params.data.alerts,
              alertStatus: params.data.alertStatus,
              cyclesCount: params.data.maintenanceRemainingCycles,
              toolUsageTime: params.data.m_maintenanceRemainingUsageTime
            };
          },
          sort: 'desc'
        },
      },
      {
        fieldName: 'toolStatus',
        title: this.labels.get('columns.status.title'),
        width: 140,
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'toolStatus',
        columnOptions: {
          valueGetter: (params) => {
            return params.data.toolStatus ? this.toolStatusLabels.get(params.data.toolStatus) : '';
          }
        }
      },
      {
        fieldName: 'lastOperation',
        title: this.labels.get('columns.lastOperation.title'),
        ffilterType: filterTypes.NONE,
        columnOptions: {
          cellComponent: LastOperationCell,
          headerComponentParams : {headerTextStyle: {marginLeft: '0px'}},
          valueGetter: (params) => {
            return params.data.lastOperation;
          }
        }
      },
      {
        fieldName: 'usage',
        title: this.labels.get('columns.usage.title'),
        filterType: filterTypes.NONE,
        width: 200,
        columnOptions: {
          cellComponent: ToolUsageProgressCell,
          sortable: false,
          valueGetter: (params) => {
            return params.data;
          }
        }
      },

      {
        fieldName: 'toolType.businessId',
        title: this.labels.get('columns.type.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'toolType',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: ({data}) => {
            return ToolTypeHelper.getToolTypeFullLabel(data.toolType.description, data.toolType.businessId);
          }
        }
      },

      {
        fieldName: 'businessId',
        title: this.labels.get('columns.toolId.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'businessId',
        fetchConfig: {
          entityType: EntityPropertyTypes.TOOL_BUSINESS_ID,
          filter: [FetchEntitiesFilters.ACTIVE],
          action: this.props.actions.fetchEntities
        },
        columnOptions: {
          cellComponent: EntityIdCell,
          valueGetter: (params) => {
            return {
              id: params.data.id,
              label: params.data.businessId,
              type: navigationStates.TOOL
            };
          }
        }
      },
      {
        fieldName: 'toolType.toolCategory.businessId',
        title: this.labels.get('columns.toolCategory.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'toolCategoryBusinessId',
        columnOptions: {
          valueGetter: ({data}) => {
            return data.toolType?.toolCategory?.businessId || '';
          }
        }
      },
      {
        fieldName: 'toolType.kitTypesWithCapacity',
        title: this.labels.get('columns.kitType.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'toolKitType',
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return params.data?.toolType?.kitTypesWithCapacity?.map(item => item.kitTypeBusinessId)?.join(', ') || [];
          },
        }
      },
      {
        fieldName: 'location',
        title: this.labels.get('columns.location.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'assetLocationName',
        filterAlignment: filterAlignmentTypes.RIGHT,
        columnOptions: {
          cellComponent: EntityIdCell,
          valueGetter: (params) => {
            return {
              id: params.data.locationId,
              type: navigationStates.LOCATION,
              label: params.data.locationName
            };
          }
        }
      },
      {
        fieldName: 'toolType.configurationType',
        title: this.labels.get('columns.kitTypesConfiguration.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'configurationType',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return getEnumLabel(enumTypes.TOOL_CONFIGURATION_TYPE)(params.data.toolType?.configurationType);
          },
        }
      },
    ]
  }


  getRowHeight() {
    return 100;
  }

  render() {
      return (
        <div className="active-tools-grid">
          <Grid gridName={gridsNames.PREDEFINED_LIST_ACTIVE_TOOLS}
                columnsConfig={this.columnsConfig}
                filterConfig={this.filterConfig}
                actions={this.props.actions}
                gridProps={
                  {
                    getRowHeight: this.getRowHeight,
                    filterPersistence: true,
                  }
                }
          >
          </Grid>
        </div>
      );
    }
 }

export default reduxForm({
    form: 'activeToolsGrid'
  }
)(ActiveToolsGrid);
